import axios from "axios";
// TODO 配置多环境 通过npm run build -- --mode=prod来区分环境 or run build:prod
const isDev = false // 是否为开发环境
const devUrl = "http://localhost:8081/api"
const prodUrl = "https://aliaba.fun/api"
const baseURL = isDev ? devUrl : prodUrl
// 不要用public/config.json外部文件，因为会被service worker缓存，导致无法更新
console.log("baseUrl: " + baseURL);
const axiosIns = axios.create({
    baseURL: baseURL
})

export default axiosIns